import { createSelector } from 'reselect';
import { MVT_WEB_POSTCODES } from '../flags/experiments';
import { whichVariant } from './configSelectors';

const getDefaultLocationSearch = (state) => state.request.country.postcodeSearch;
const getPostcodeSearchMVT = (state) => whichVariant(state, MVT_WEB_POSTCODES);

export const getIsPostcodeSearch = createSelector(
  [getDefaultLocationSearch, getPostcodeSearchMVT],
  (isPostcodeSearch, postcodeSearchVariant) => {
    /*
        If the MVT isn't active then return the default postcode search value from app/config.js
        Otherwise check the variant value to determine if the user should see postcode search or geolocation search.
    */
    if (!postcodeSearchVariant) return isPostcodeSearch;

    if (postcodeSearchVariant === 'use_postcodes') {
      return true;
    }
    return false;
  },
);
